<template>
  <v-container>
    <v-btn color="primary" class="modify-round-btn" @click="sheet = !sheet" fixed bottom right fab>
      <v-icon>tune</v-icon>
    </v-btn>
    <v-bottom-sheet v-model="sheet" id="sheet">
      <form id="form" ref="form" >
      <v-sheet class="text-center activate-overflow altura">
        <v-layout xs12 sm12 md12 lg12 justify-end px-3 pt-3 pb-1>
          <v-btn small text icon @click="sheet = !sheet" right>
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>

        <v-layout wrap pb-1 pl-5 pr-5>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-text-field v-model="storeFilters.idIncidence" id="storeFilters.idIncidence" clearable
              :label="$t('sectionInformes.filtros.numIncidencia')"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" v-model="codigoTipoSolicitudesValue" id="codigoTipoSolicitudesValue" :items="tiposSolicitudes"
              :label="$t('sectionInformes.filtros.tipoSolicitud')" item-text="descripcionTipoSolicitud"
              item-value="codigoTipoSolicitud" clearable />
          </v-flex>

          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="getEstados" item-text="name" clearable sort-by="code"
              item-value="id" :label="$t('sectionInformes.filtros.estado')" v-model="storeFilters.status" id="storeFilters.status"></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap pb-1 pl-5 pr-5>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="promosCliente" clearable
              v-model="storeFilters.propertyDevelopment" id="storeFilters.propertyDevelopment" item-value="id" sort-by="code"
              :label="$t('sectionInformes.filtros.promocion')" @change="generarInmuebles(storeFilters.propertyDevelopment)">
                <template v-slot:selection="data">
                  {{ data.item.code }} - {{ data.item.name }}
                </template>
                <template v-slot:item="data">
                  {{ data.item.code }} - {{ data.item.name }}
                </template>
              </v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="inmueblesCliente" v-model="storeFilters.selectedPropertyDesc" id="storeFilters.selectedPropertyDesc"
              :disabled="!storeFilters.propertyDevelopment"
              :label="$t('sectionInformes.filtros.inmueble')"
              item-value="" item-text="ALIAS"></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 pl-3 pr-3>
            <v-autocomplete :no-data-text="$t('sinDatos')" :items="getterUrgencias" item-text="text" clearable sort-by="code"
              item-value="value" :label="$t('sectionInformes.filtros.urgencia')" v-model="storeFilters.severityId" id="storeFilters.severityId"></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout wrap pt-1 pb-1 pl-2 pr-2 justify-end>
          <v-flex xs12 sm12 md3 lg3 pl-1 pr-1>
            <v-btn color="primary" class="mr-1 pa-1" @click="borrarFiltros()">{{ $t('sectionInformes.filtros.borrar') }}</v-btn>
            <v-btn color="primary" class="pa-1" @click="launchFilters()">{{ $t('sectionInformes.filtros.aplicar') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-sheet>
      </form>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    storeFilters: {
      type: Object,
      required: true
    },
    codigoTipoSolicitudes: {
      default: null
    }
  },
  name: 'Filters',
  data () {
    return {
      codigoTipoSolicitudesValue: '',
      selectedPromoId: '',
      sheet: false,
      selectedReclamacionId: '',
      promosCliente: [],
      inmueblesCliente: []
    }
  },
  created () {
    const datosIdubapi = JSON.parse(localStorage.idubapi)
    this.promosCliente = datosIdubapi.promociones

    this.getEstados.length === 1 ? this.storeFilters.status = this.getEstados[0].id : this.storeFilters.status
    this.tiposSolicitudes.length === 1 ? this.codigoTipoSolicitudesValue = this.tiposSolicitudes[0] : this.codigoTipoSolicitudesValue
    this.promosCliente.length === 1 ? this.storeFilters.propertyDevelopment = this.promosCliente[0].id : this.storeFilters.propertyDevelopment
    this.getterUrgencias.length === 1 ? this.storeFilters.severityId = this.getterUrgencias[0].value : this.storeFilters.severityId

    if(this.promosCliente.length === 1) {
      this.generarInmuebles(this.storeFilters.propertyDevelopment)
    }
  },
  computed: {
    ...mapGetters({
      tiposSolicitudes: 'configuracion/getTiposSolicitud',
      getterUrgencias: 'incidencias/getUrgencias'
    }),
    getEstados () {
      if (this.$store.state.incidencias.estados) {
        return this.$store.state.incidencias.estados
      }
      return []
    }
  },
  methods: {
    ...mapActions({
      getStatusTypes: 'incidencias/getStatusTypes',
      getVisitTypes: 'incidencias/getVisitTypes',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      getPropertiesByStringAndPropertyDevId: 'incidencias/getPropertiesByStringAndPropertyDevId',
      getIncidencias: 'incidencias/getIncidencias',
      getUrgencias: 'incidencias/getUrgencias',
      getAllRoomPropertyTypes: 'incidencias/getAllRoomPropertyTypes',
    }),
    launchFilters () {
      this.storeFilters.codigoTipoSolicitud = this.codigoTipoSolicitudesValue

      this.$store.commit('incidencias/setFiltrosCliente', this.storeFilters)
      this.$emit('valoresFiltros', this.storeFilters)

      if (this.codigoTipoSolicitudes !== null) {
        this.$router.push({ name: 'incidencias', query: { codigoTipoSolicitudes: this.codigoTipoSolicitudes } })
      }
      this.sheet = !this.sheet
    },
    borrarFiltros () {
      this.storeFilters.idIncidence = ''
      this.storeFilters.codigoTipoSolicitud = ''
      this.storeFilters.codigoTipoSolicitudes = ''
      this.codigoTipoSolicitudesValue = ''

      this.storeFilters.status = ''

      this.storeFilters.propertyDevelopment = null
      this.storeFilters.selectedPropertyDesc = ''

      this.storeFilters.selectedProperty = {
        promocionId: '',
        inmuebleId: '',
        inmuebleEspecialId: '',
        uhedit: '',
        cliente: '',
        direccion: ''
      }
      this.storeFilters.severityId = ''
    },
    generarInmuebles (promoSelected) {
      console.log('promo sel', promoSelected)
      const promoSelectedFull = this.promosCliente.find( e=> {
        return e.id === promoSelected
      })
      this.inmueblesCliente = promoSelectedFull.inmuebles
      if (this.inmueblesCliente.length === 1) {
        console.log('ENTRO AQUI')
        this.storeFilters.selectedPropertyDesc = this.inmueblesCliente[0].ALIAS
      }
    }
  },
  mounted () {
    this.codigoTipoSolicitudesValue = this.codigoTipoSolicitudes
    this.getStatusTypes()
    this.getVisitTypes()
    this.getPropertiesDevelopment()
    this.getAllRoomPropertyTypes()
    this.getUrgencias()
  },
  watch: {
    async codigoTipoSolicitudesValue (newVal) {
      if (newVal === undefined) {
        this.codigoTipoSolicitudesValue = null
      }
      this.$emit('codigoTipoSolicitudesInput', this.codigoTipoSolicitudesValue)
    }
  }
}
</script>

<style scoped>

.v-btn--fab.v-size--default.v-btn--absolute.v-btn--top {
  top: 65px;
}
.activate-overflow {
  overflow-y: scroll;
}

#filters-divider {
  margin-left: .5em;
}
.modify-round-btn {
  height: 45px !important;
  width: 45px !important;
}
.v-btn--absolute.v-btn--bottom, .v-btn--fixed.v-btn--bottom {
  bottom: 10px;
}

@media (max-width: 1366px) {
  .altura {
    height: 35vh;
  }
}

@media (min-width: 1367px) and (max-width: 1600px) {
  .altura {
    height: 30vh;
  }
}

@media (min-width: 1601px) {
  .altura {
    height: 25vh;
  }
}
</style>
